import { render, staticRenderFns } from "./ReviewTagsSettingsListItem.vue?vue&type=template&id=d1e78c06&scoped=true&"
import script from "./ReviewTagsSettingsListItem.vue?vue&type=script&lang=js&"
export * from "./ReviewTagsSettingsListItem.vue?vue&type=script&lang=js&"
import style0 from "./ReviewTagsSettingsListItem.vue?vue&type=style&index=0&id=d1e78c06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1e78c06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VIcon,VTextField,VTooltip})
